import { useShellBodyResize } from './shellBodyResize/ShellBodyResizeContext'

/**
 * True when the app shell center column is collapsed under an expanded side panel
 * (e.g. AI chat `railExpanded`). Use to hide viewport-fixed overlays that portal
 * outside `#shell-content` and would otherwise remain visible.
 */
export function useShellCenterPanelCollapsed(): boolean {
  return useShellBodyResize().centerPanelCollapsed
}
